import * as React from 'react';
import {withRouter, RouteComponentProps} from 'react-router';
import {Link} from 'react-router-dom';
import Header from '../../components/Header/Header';
import {connect, GlobalProps} from '../../stores/GlobalStore';
import {Icon} from 'antd';

import UserClient from '../../api/UserClient';

export interface JungProfile{
  pontuacao: number[],
  sigla: string,
  __v: number,
  _id: string,
  _user: string
}

export interface State{
  name: string,
  _resultadosJung: JungProfile[],
  _resultadosHolland: any[]

}

import styles from './ProfilePage.module.scss';
class ProfilePage extends React.Component<{} & RouteComponentProps & GlobalProps, State>{

  public state = {
    name: '',
    _resultadosJung: [],
    _resultadosHolland: []
  };


  public render(){

    const [jungResult = {sigla: ''}] = this.state._resultadosJung;
    const [hollandResult = {_id: ''}] = this.state._resultadosHolland;


    return (
      <div className={styles.profilePage}>
        <Header page={'Perfil'} reloadable={false}/>
        <div className={styles.userProfile}>
          <Icon type={'user'} style={{fontSize: 34}}/>
          <h3>Olá, {this.state.name}</h3>
        </div>
        <h2>Meus resultados</h2>
        <div className={styles.tests}>
          {!this.state._resultadosJung.length && (
            <Link to={'/jung'} className={styles.withNoResult}>
              <strong>Perfil Jung</strong>
              {!this.state._resultadosJung.length &&
              <p>Clique aqui para fazer o questionário!</p>
              }
            </Link>
          )}
          {(!!this.state._resultadosJung.length) && (
            <Link to={`/resultado-jung/${jungResult.sigla}`} className={styles.withResult}>
              <strong>Perfil Jung</strong>
            </Link>
          )}




          {!this.state._resultadosHolland.length && (
            <Link to={'/holland'}
                  className={styles.withNoResult}>
              <strong>Perfil Holland</strong>
              {!this.state._resultadosHolland.length &&
              <p>Clique aqui para fazer o questionário!</p>
              }
            </Link>
          )}
          {(!!this.state._resultadosHolland.length) && (
            <Link to={`/resultado-holland/${hollandResult._id}`} className={styles.withResult}>
              <strong>Perfil Holland</strong>
            </Link>
          )}
        </div>
      </div>
    )
  }

  public async componentDidMount(){

    const response = await UserClient().getUser(this.props.authToken);

    this.setState({
      name: response.firstname,
      _resultadosJung: response._resultadosJung,
      _resultadosHolland: response._resultadosHolland,
    });
  }

}


export default withRouter(connect(ProfilePage, 'authToken'));
